<script setup lang="ts">
import WarningIcon from '../assets/icon-warning.svg?component';

defineProps<{
	content: string;
}>();
</script>

<template>
	<WarningIcon
		v-tippy="content"
		class="fill-warning"
	/>
</template>
